var map = {
	"./ContentSlider/ContentSlider": [
		298,
		9
	],
	"./ContentSlider/ContentSlider.tsx": [
		298,
		9
	],
	"./ContentSlider/Slide": [
		302,
		9
	],
	"./ContentSlider/Slide.tsx": [
		302,
		9
	],
	"./ContentSlider/chaptersBar": [
		283,
		9
	],
	"./ContentSlider/chaptersBar.style": [
		300,
		9
	],
	"./ContentSlider/chaptersBar.style.ts": [
		300,
		9
	],
	"./ContentSlider/chaptersBar.tsx": [
		283,
		9
	],
	"./ContentSlider/contentSlider.style": [
		301,
		9
	],
	"./ContentSlider/contentSlider.style.ts": [
		301,
		9
	],
	"./ContentSlider/vb_intro.svg": [
		2402,
		9,
		538
	],
	"./ContentSlider/vb_outro.svg": [
		2403,
		9,
		539
	],
	"./Cover": [
		438,
		9,
		0,
		1,
		2,
		3,
		46
	],
	"./Cover/": [
		438,
		9,
		0,
		1,
		2,
		3,
		46
	],
	"./Cover/CoverWrapper": [
		760,
		9,
		312
	],
	"./Cover/CoverWrapper.tsx": [
		760,
		9,
		312
	],
	"./Cover/IEbuttons": [
		792,
		9,
		254
	],
	"./Cover/IEbuttons.tsx": [
		792,
		9,
		254
	],
	"./Cover/cover.style": [
		1005,
		9,
		313
	],
	"./Cover/cover.style.ts": [
		1005,
		9,
		313
	],
	"./Cover/index": [
		438,
		9,
		0,
		1,
		2,
		3,
		46
	],
	"./Cover/index.tsx": [
		438,
		9,
		0,
		1,
		2,
		3,
		46
	],
	"./HOC/withHover": [
		132,
		9
	],
	"./HOC/withHover.css": [
		682,
		7
	],
	"./HOC/withHover.tsx": [
		132,
		9
	],
	"./ImageModule": [
		327,
		9,
		6,
		25
	],
	"./ImageModule/": [
		327,
		9,
		6,
		25
	],
	"./ImageModule/index": [
		327,
		9,
		6,
		25
	],
	"./ImageModule/index.tsx": [
		327,
		9,
		6,
		25
	],
	"./InteractivePanelTitle/InteractivePanelTitle": [
		731,
		9,
		275
	],
	"./InteractivePanelTitle/InteractivePanelTitle.tsx": [
		731,
		9,
		275
	],
	"./InteractivePanelTitle/interactivePanelTitle.style": [
		730,
		9,
		314
	],
	"./InteractivePanelTitle/interactivePanelTitle.style.ts": [
		730,
		9,
		314
	],
	"./Intro": [
		439,
		9,
		127
	],
	"./Intro/": [
		439,
		9,
		127
	],
	"./Intro/index": [
		439,
		9,
		127
	],
	"./Intro/index.tsx": [
		439,
		9,
		127
	],
	"./Intro/introPage.style": [
		1006,
		9,
		315
	],
	"./Intro/introPage.style.ts": [
		1006,
		9,
		315
	],
	"./LoadingSpinner": [
		173,
		9
	],
	"./LoadingSpinner/": [
		173,
		9
	],
	"./LoadingSpinner/index": [
		173,
		9
	],
	"./LoadingSpinner/index.tsx": [
		173,
		9
	],
	"./LoadingSpinner/spinner.svg": [
		531,
		9
	],
	"./Logo": [
		440,
		9,
		128
	],
	"./Logo/": [
		440,
		9,
		128
	],
	"./Logo/index": [
		440,
		9,
		128
	],
	"./Logo/index.style": [
		1007,
		9,
		316
	],
	"./Logo/index.style.ts": [
		1007,
		9,
		316
	],
	"./Logo/index.tsx": [
		440,
		9,
		128
	],
	"./NextChapterCover": [
		441,
		9,
		91
	],
	"./NextChapterCover/": [
		441,
		9,
		91
	],
	"./NextChapterCover/Loader": [
		303,
		9
	],
	"./NextChapterCover/Loader.tsx": [
		303,
		9
	],
	"./NextChapterCover/index": [
		441,
		9,
		91
	],
	"./NextChapterCover/index.tsx": [
		441,
		9,
		91
	],
	"./NextChapterCover/nextChapterCover.style": [
		1008,
		9,
		317
	],
	"./NextChapterCover/nextChapterCover.style.ts": [
		1008,
		9,
		317
	],
	"./Overlay": [
		182,
		9
	],
	"./Overlay/": [
		182,
		9
	],
	"./Overlay/index": [
		182,
		9
	],
	"./Overlay/index.tsx": [
		182,
		9
	],
	"./Overlay/overlay.style": [
		299,
		9
	],
	"./Overlay/overlay.style.ts": [
		299,
		9
	],
	"./Section/Section": [
		936,
		9,
		255
	],
	"./Section/Section.tsx": [
		936,
		9,
		255
	],
	"./Section/SectionStickyBackground": [
		846,
		9,
		276
	],
	"./Section/SectionStickyBackground.tsx": [
		846,
		9,
		276
	],
	"./Section/SectionTextContent": [
		1095,
		9,
		256
	],
	"./Section/SectionTextContent.tsx": [
		1095,
		9,
		256
	],
	"./Section/SectionTitle": [
		806,
		9,
		277
	],
	"./Section/SectionTitle.tsx": [
		806,
		9,
		277
	],
	"./Section/SectionWrapper": [
		308,
		9
	],
	"./Section/SectionWrapper.tsx": [
		308,
		9
	],
	"./Section/section.style": [
		749,
		9,
		318
	],
	"./Section/section.style.ts": [
		749,
		9,
		318
	],
	"./TabsContainer": [
		347,
		9,
		112
	],
	"./TabsContainer/": [
		347,
		9,
		112
	],
	"./TabsContainer/Tab": [
		1096,
		9,
		278
	],
	"./TabsContainer/Tab.tsx": [
		1096,
		9,
		278
	],
	"./TabsContainer/TabsContainer.style": [
		827,
		9,
		319
	],
	"./TabsContainer/TabsContainer.style.ts": [
		827,
		9,
		319
	],
	"./TabsContainer/components/glossary": [
		442,
		9,
		82
	],
	"./TabsContainer/components/glossary/": [
		442,
		9,
		82
	],
	"./TabsContainer/components/glossary/Alphabet": [
		1010,
		9,
		279
	],
	"./TabsContainer/components/glossary/Alphabet.style": [
		880,
		9,
		320
	],
	"./TabsContainer/components/glossary/Alphabet.style.ts": [
		880,
		9,
		320
	],
	"./TabsContainer/components/glossary/Alphabet.tsx": [
		1010,
		9,
		279
	],
	"./TabsContainer/components/glossary/Glossary.style": [
		1011,
		9,
		321
	],
	"./TabsContainer/components/glossary/Glossary.style.ts": [
		1011,
		9,
		321
	],
	"./TabsContainer/components/glossary/icons/icon.svg": [
		2404,
		9,
		540
	],
	"./TabsContainer/components/glossary/icons/iconAlt.svg": [
		2405,
		9,
		541
	],
	"./TabsContainer/components/glossary/index": [
		442,
		9,
		82
	],
	"./TabsContainer/components/glossary/index.tsx": [
		442,
		9,
		82
	],
	"./TabsContainer/components/videogallery": [
		443,
		9,
		129
	],
	"./TabsContainer/components/videogallery/": [
		443,
		9,
		129
	],
	"./TabsContainer/components/videogallery/GalleryItem": [
		1097,
		9,
		0,
		1,
		2,
		3,
		197
	],
	"./TabsContainer/components/videogallery/GalleryItem.tsx": [
		1097,
		9,
		0,
		1,
		2,
		3,
		197
	],
	"./TabsContainer/components/videogallery/gallery.style": [
		1013,
		9,
		322
	],
	"./TabsContainer/components/videogallery/gallery.style.ts": [
		1013,
		9,
		322
	],
	"./TabsContainer/components/videogallery/galleryItem.style": [
		1012,
		9,
		323
	],
	"./TabsContainer/components/videogallery/galleryItem.style.ts": [
		1012,
		9,
		323
	],
	"./TabsContainer/components/videogallery/icons/icon.svg": [
		2406,
		9,
		542
	],
	"./TabsContainer/components/videogallery/icons/iconAlt.svg": [
		2407,
		9,
		543
	],
	"./TabsContainer/components/videogallery/index": [
		443,
		9,
		129
	],
	"./TabsContainer/components/videogallery/index.tsx": [
		443,
		9,
		129
	],
	"./TabsContainer/components/worksheets": [
		444,
		9,
		78
	],
	"./TabsContainer/components/worksheets/": [
		444,
		9,
		78
	],
	"./TabsContainer/components/worksheets/WorksheetItem": [
		1014,
		9,
		245
	],
	"./TabsContainer/components/worksheets/WorksheetItem.tsx": [
		1014,
		9,
		245
	],
	"./TabsContainer/components/worksheets/icons/icon.svg": [
		2408,
		9,
		544
	],
	"./TabsContainer/components/worksheets/icons/iconAlt.svg": [
		2409,
		9,
		545
	],
	"./TabsContainer/components/worksheets/index": [
		444,
		9,
		78
	],
	"./TabsContainer/components/worksheets/index.tsx": [
		444,
		9,
		78
	],
	"./TabsContainer/components/worksheets/worksheet.style": [
		1015,
		9,
		324
	],
	"./TabsContainer/components/worksheets/worksheet.style.ts": [
		1015,
		9,
		324
	],
	"./TabsContainer/components/worksheets/worksheetItem.style": [
		881,
		9,
		325
	],
	"./TabsContainer/components/worksheets/worksheetItem.style.ts": [
		881,
		9,
		325
	],
	"./TabsContainer/index": [
		347,
		9,
		112
	],
	"./TabsContainer/index.tsx": [
		347,
		9,
		112
	],
	"./TabsContainer/tab.style": [
		1009,
		9,
		326
	],
	"./TabsContainer/tab.style.ts": [
		1009,
		9,
		326
	],
	"./ThumbnailWithIcon": [
		355,
		9,
		130
	],
	"./ThumbnailWithIcon/": [
		355,
		9,
		130
	],
	"./ThumbnailWithIcon/index": [
		355,
		9,
		130
	],
	"./ThumbnailWithIcon/index.tsx": [
		355,
		9,
		130
	],
	"./ThumbnailWithIcon/thumbnailWithIcon.style": [
		874,
		9,
		327
	],
	"./ThumbnailWithIcon/thumbnailWithIcon.style.ts": [
		874,
		9,
		327
	],
	"./buttons/topBar/Close": [
		354,
		9,
		131
	],
	"./buttons/topBar/Close/": [
		354,
		9,
		131
	],
	"./buttons/topBar/Close/index": [
		354,
		9,
		131
	],
	"./buttons/topBar/Close/index.style": [
		871,
		9,
		328
	],
	"./buttons/topBar/Close/index.style.ts": [
		871,
		9,
		328
	],
	"./buttons/topBar/Close/index.tsx": [
		354,
		9,
		131
	],
	"./buttons/topBar/Legal": [
		445,
		9,
		77
	],
	"./buttons/topBar/Legal/": [
		445,
		9,
		77
	],
	"./buttons/topBar/Legal/index": [
		445,
		9,
		77
	],
	"./buttons/topBar/Legal/index.style": [
		1016,
		9,
		329
	],
	"./buttons/topBar/Legal/index.style.ts": [
		1016,
		9,
		329
	],
	"./buttons/topBar/Legal/index.tsx": [
		445,
		9,
		77
	],
	"./buttons/topBar/Meta": [
		446,
		9,
		103
	],
	"./buttons/topBar/Meta/": [
		446,
		9,
		103
	],
	"./buttons/topBar/Meta/index": [
		446,
		9,
		103
	],
	"./buttons/topBar/Meta/index.style": [
		1017,
		9,
		330
	],
	"./buttons/topBar/Meta/index.style.ts": [
		1017,
		9,
		330
	],
	"./buttons/topBar/Meta/index.tsx": [
		446,
		9,
		103
	],
	"./buttons/topBar/Share": [
		447,
		9,
		53
	],
	"./buttons/topBar/Share/": [
		447,
		9,
		53
	],
	"./buttons/topBar/Share/icons/share.svg": [
		1932,
		9,
		546
	],
	"./buttons/topBar/Share/icons/socialFacebook.svg": [
		1933,
		9,
		547
	],
	"./buttons/topBar/Share/icons/socialInstagram.svg": [
		2410,
		9,
		548
	],
	"./buttons/topBar/Share/icons/socialTwitter.svg": [
		1934,
		9,
		549
	],
	"./buttons/topBar/Share/index": [
		447,
		9,
		53
	],
	"./buttons/topBar/Share/index.style": [
		1018,
		9,
		331
	],
	"./buttons/topBar/Share/index.style.ts": [
		1018,
		9,
		331
	],
	"./buttons/topBar/Share/index.tsx": [
		447,
		9,
		53
	],
	"./common/IEBanner/BannerOverlay": [
		296,
		9
	],
	"./common/IEBanner/BannerOverlay.tsx": [
		296,
		9
	],
	"./common/IEBanner/CookiesBanner": [
		291,
		9
	],
	"./common/IEBanner/CookiesBanner.tsx": [
		291,
		9
	],
	"./common/IEBanner/IEBanner": [
		292,
		9
	],
	"./common/IEBanner/IEBanner.tsx": [
		292,
		9
	],
	"./common/IEBanner/cookiesBanner.style": [
		294,
		9
	],
	"./common/IEBanner/cookiesBanner.style.ts": [
		294,
		9
	],
	"./common/IEBanner/iebanner.style": [
		297,
		9
	],
	"./common/IEBanner/iebanner.style.ts": [
		297,
		9
	],
	"./common/ScrollPage": [
		118,
		9
	],
	"./common/ScrollPage.tsx": [
		118,
		9
	],
	"./common/elements/HeaderTitle": [
		750,
		9,
		280
	],
	"./common/elements/HeaderTitle.tsx": [
		750,
		9,
		280
	],
	"./common/elements/ResponsiveImage": [
		748,
		9,
		332
	],
	"./common/elements/ResponsiveImage.tsx": [
		748,
		9,
		332
	],
	"./common/elements/buttons": [
		117,
		9
	],
	"./common/elements/buttons.tsx": [
		117,
		9
	],
	"./common/elements/headerTitle.style": [
		747,
		9,
		333
	],
	"./common/elements/headerTitle.style.ts": [
		747,
		9,
		333
	],
	"./common/elements/overlays/SmartSwipeOverlay": [
		230,
		9
	],
	"./common/elements/overlays/SmartSwipeOverlay.tsx": [
		230,
		9
	],
	"./common/legal/LegalButton": [
		1001,
		9,
		223
	],
	"./common/legal/LegalButton.tsx": [
		1001,
		9,
		223
	],
	"./common/legal/impressum/ImpressumContainer": [
		814,
		9,
		281
	],
	"./common/legal/impressum/ImpressumContainer.tsx": [
		814,
		9,
		281
	],
	"./common/legal/impressum/impressumContainer.style": [
		791,
		9,
		334
	],
	"./common/legal/impressum/impressumContainer.style.ts": [
		791,
		9,
		334
	],
	"./common/legal/legalButton.style": [
		879,
		9,
		335
	],
	"./common/legal/legalButton.style.ts": [
		879,
		9,
		335
	],
	"./common/scrollPage.style": [
		304,
		9
	],
	"./common/scrollPage.style.ts": [
		304,
		9
	],
	"./common/scrollSidebar/ScrollSideBar": [
		305,
		9
	],
	"./common/scrollSidebar/ScrollSideBar.tsx": [
		305,
		9
	],
	"./common/scrollSidebar/scrollSideBar.style": [
		307,
		9
	],
	"./common/scrollSidebar/scrollSideBar.style.ts": [
		307,
		9
	],
	"./common/svg_paths/export_path_bg_quiz_v2.svg": [
		2411,
		9,
		550
	],
	"./common/video/SimpleVideoPlayer": [
		831,
		9,
		1,
		2,
		3,
		282
	],
	"./common/video/SimpleVideoPlayer.tsx": [
		831,
		9,
		1,
		2,
		3,
		282
	],
	"./common/video/videoContainer": [
		737,
		9,
		0,
		1,
		2,
		3,
		215
	],
	"./common/video/videoContainer.style": [
		738,
		9,
		336
	],
	"./common/video/videoContainer.style.ts": [
		738,
		9,
		336
	],
	"./common/video/videoContainer.tsx": [
		737,
		9,
		0,
		1,
		2,
		3,
		215
	],
	"./common/video/videoplayer": [
		729,
		9,
		0,
		1,
		2,
		3,
		228
	],
	"./common/video/videoplayer.style": [
		728,
		9,
		337
	],
	"./common/video/videoplayer.style.ts": [
		728,
		9,
		337
	],
	"./common/video/videoplayer.tsx": [
		729,
		9,
		0,
		1,
		2,
		3,
		228
	],
	"./factories/InlineSubcontentWidget": [
		241,
		9
	],
	"./factories/InlineSubcontentWidget.tsx": [
		241,
		9
	],
	"./factories/contentFactory": [
		237,
		9
	],
	"./factories/contentFactory.tsx": [
		237,
		9
	],
	"./factories/inlineSubcontentWidget.style": [
		293,
		9
	],
	"./factories/inlineSubcontentWidget.style.ts": [
		293,
		9
	],
	"./icons/arrowDown.svg": [
		278,
		9
	],
	"./icons/arrowLeft.svg": [
		525,
		9
	],
	"./icons/arrowLeftDark.svg": [
		526,
		9
	],
	"./icons/arrowRight.svg": [
		508,
		9
	],
	"./icons/arrowRightDark.svg": [
		527,
		9
	],
	"./icons/checkGreen.svg": [
		1857,
		9,
		551
	],
	"./icons/cross.svg": [
		279,
		9
	],
	"./icons/crossBlack.svg": [
		187,
		9
	],
	"./icons/crossDark.svg": [
		318,
		9
	],
	"./icons/crossRed.svg": [
		1858,
		9,
		552
	],
	"./icons/info.svg": [
		1856,
		9,
		553
	],
	"./icons/menu.svg": [
		528,
		9
	],
	"./icons/menuClose.svg": [
		529,
		9
	],
	"./icons/metaMobile.svg": [
		1931,
		9,
		554
	],
	"./icons/scrollingArrow.svg": [
		530,
		9
	],
	"./icons/vertiefungArbeitsblatt.svg": [
		1842,
		9,
		555
	],
	"./icons/vertiefungsGallery.svg": [
		1832,
		9,
		556
	],
	"./icons/vertiefungsGraphics.svg": [
		1841,
		9,
		557
	],
	"./icons/vertiefungsImage.svg": [
		1866,
		9,
		558
	],
	"./icons/vertiefungsPause.svg": [
		1809,
		9,
		559
	],
	"./icons/vertiefungsPlay.svg": [
		1807,
		9,
		560
	],
	"./icons/vertiefungsText.svg": [
		1830,
		9,
		561
	],
	"./legal/impressum/ImpressumContainerList": [
		1098,
		9,
		283
	],
	"./legal/impressum/ImpressumContainerList.tsx": [
		1098,
		9,
		283
	],
	"./legal/impressum/impressumContainerList.style": [
		1019,
		9,
		338
	],
	"./legal/impressum/impressumContainerList.style.tsx": [
		1019,
		9,
		338
	],
	"./topbar/TopBar": [
		309,
		9
	],
	"./topbar/TopBar.tsx": [
		309,
		9
	],
	"./topbar/TopBarButtons": [
		311,
		9
	],
	"./topbar/TopBarButtons.style": [
		312,
		9
	],
	"./topbar/TopBarButtons.style.ts": [
		312,
		9
	],
	"./topbar/TopBarButtons.tsx": [
		311,
		9
	],
	"./topbar/icon": [
		826,
		9,
		339
	],
	"./topbar/icon.tsx": [
		826,
		9,
		339
	],
	"./topbar/topBar.style": [
		310,
		9
	],
	"./topbar/topBar.style.ts": [
		310,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1387;
module.exports = webpackAsyncContext;